import { useSubscription } from "@/contexts/SubscriptionContext";
import { MainLayout } from "@/components/layout/MainLayout";
import { useNavigate } from "react-router-dom";
import { Lock, CreditCard, ArrowRight, ShoppingCart, Package } from "lucide-react";

export const BlockedModuleGuard = ({ module, children }) => {
  const { isBlocked, plan, getModuleInfo } = useSubscription();
  const navigate = useNavigate();

  if (!isBlocked(module)) return children;

  const moduleInfo = getModuleInfo(module);
  const planLabels = { basic: "Básico", professional: "Profissional", pro: "Profissional", premium: "Premium", enterprise: "Enterprise" };

  return (
    <MainLayout>
      <div className="max-w-lg mx-auto text-center py-16 space-y-6" data-testid="blocked-module-overlay">
        <div className="w-20 h-20 rounded-2xl bg-amber-50 flex items-center justify-center mx-auto">
          <Lock className="w-10 h-10 text-amber-500" />
        </div>
        
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Módulo Premium</h2>
          <p className="text-lg font-semibold text-gray-700 mt-2">
            {moduleInfo?.name || module}
          </p>
          <p className="text-gray-500 mt-1">
            Este módulo faz parte de um plano premium ou pode ser contratado separadamente no Marketplace.
          </p>
        </div>
        
        <div className="bg-gray-50 rounded-2xl p-6 text-left space-y-4">
          <p className="text-sm text-gray-600">
            Seu plano atual (<strong className="capitalize">{planLabels[plan] || plan}</strong>) não inclui este recurso.
          </p>
          
          <p className="text-sm text-gray-600">
            Você pode:
          </p>
          
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2">
              <Package className="w-4 h-4 text-emerald-500" />
              <span>Assinar o módulo individualmente no <strong>Marketplace</strong></span>
              {moduleInfo?.price && (
                <span className="text-emerald-600 font-bold">€{moduleInfo.price.toFixed(2)}/mês</span>
              )}
            </li>
            <li className="flex items-center gap-2">
              <CreditCard className="w-4 h-4 text-blue-500" />
              <span>Fazer upgrade para um plano superior que inclui este recurso</span>
            </li>
          </ul>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate("/marketplace")}
            className="px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-bold transition-colors inline-flex items-center justify-center gap-2"
            data-testid="go-marketplace-btn"
          >
            <ShoppingCart className="w-4 h-4" /> 
            Ver Marketplace
          </button>
          
          <button
            onClick={() => navigate("/settings?tab=subscription")}
            className="px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl font-bold transition-colors inline-flex items-center justify-center gap-2"
            data-testid="upgrade-plan-btn"
          >
            <CreditCard className="w-4 h-4" /> 
            Ver Planos
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </MainLayout>
  );
};
